import { Menu, Transition } from "@headlessui/react"
import React, { Fragment} from "react"

export interface MenuFormItem {
    name: string,
    id: any,
    [x: string]: any
}

interface IProps {
    data: Array<MenuFormItem>,
    children: any,
    onClick?: (id: number | string) => void,
    classForList?: string
}

function MenuForm(props: IProps) {
    const {data, children, onClick, classForList = "w-32"} = props

    const $menuItem = (item: MenuFormItem, idx: number) => {
        return (
            <Menu.Item key={idx}>
                {({ active }) => (
                    <button
                        onClick={() => {
                            onClick && onClick(item.id)
                        }}
                        className={`${
                            active ? "bg-theme-blue-10 text-theme-blue font-semibold" : "bg-white text-gray-1 font-normal"
                        } w-full py-2 px-4 text-sm text-left rounded`}
                    >
                        {item.name}
                    </button>
                )}
            </Menu.Item>
        )
    }
    return (
        <div className="max-w-max flex flex-col justify-center bg-white">
            <Menu as="div" className="relative inline-block text-left">
                <div className={"flex flex-col justify-center"}>
                    <Menu.Button className="">
                        {children}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className={`z-30 p-1 bg-white absolute right-0 mt-2 min-w-full origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none ${classForList}`}>
                        {data.map((_item, idx) => {
                            return $menuItem(_item, idx)
                        })}
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}

export default MenuForm
